import Badge from 'react-bootstrap/Badge'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Stack from 'react-bootstrap/Stack'

import { formatCurrency, severityTone } from './attendanceIntelligenceUtils'

const INSIGHT_TYPE_LABELS = {
  high_no_shows: 'High no-shows',
  late_arrivals: 'Late arrivals',
  underused_sections: 'Underused sections',
  gate_congestion: 'Gate congestion',
  segment_attendance: 'Segment attendance',
}

function InsightCard({ insight }) {
  const tone = severityTone(insight.severity)
  const typeLabel =
    INSIGHT_TYPE_LABELS[insight.insightType] || insight.insightType

  return (
    <Card
      body
      className={`card--xs card-with-border h-100 attendance-insight-card attendance-insight-card--${tone}`}
    >
      <Stack gap={2} className="h-100">
        <Stack direction="horizontal" className="flex-wrap gap-2">
          <Badge bg="light" text="dark">
            {typeLabel}
          </Badge>
          <Badge
            bg={
              insight.severity === 'critical'
                ? 'danger'
                : insight.severity === 'warning'
                  ? 'warning'
                  : 'secondary'
            }
          >
            {insight.severity || 'info'}
          </Badge>
        </Stack>
        <h3 className="h6 mb-0">{insight.title}</h3>
        {insight.summary ? (
          <p className="small text-muted mb-0">{insight.summary}</p>
        ) : null}
        {insight.recommendation ? (
          <p className="small mb-0">{insight.recommendation}</p>
        ) : null}
        {insight.estimatedImpact != null && insight.estimatedImpact > 0 ? (
          <p className="small mb-0 attendance-insight-card__impact">
            Est. impact: {formatCurrency(insight.estimatedImpact)}
          </p>
        ) : null}
      </Stack>
    </Card>
  )
}

export default function AttendanceIntelligenceInsightCards({ insightCards }) {
  if (!insightCards?.length) {
    return (
      <p className="text-muted small mb-0">
        No attendance insights yet. Insights appear once scan data is available.
      </p>
    )
  }

  return (
    <Row className="g-3">
      {insightCards.map((insight, index) => (
        <Col key={`${insight.insightType}-${index}`} md={6} xl={4}>
          <InsightCard insight={insight} />
        </Col>
      ))}
    </Row>
  )
}
